import { ROUTE } from '@/constants';
import { loadView } from '../index';

const HomeView = loadView('home/HomeView');

const homeRoute = {
  path: ROUTE.PATH.HOME,
  component: () => import('@/layouts/default/DefaultLayout.vue'),
  meta: {
    auth: ROUTE.AUTH.USER_ROLE.AUTHENTICATED,
  },
  children: [
    {
      path: '',
      name: ROUTE.NAME.HOME,
      component: HomeView,
      meta: {
        auth: ROUTE.AUTH.USER_ROLE.AUTHENTICATED,
      },
    },
  ],
};

export default homeRoute;
